import { useIntl } from "react-intl";

import Badge, { type BadgeColor } from "components/v2/Badge/Badge";
import { ReactComponent as InfoCircleIcon } from "assets/images/iconsV2/info-circle.svg";

import "./ParcelWarningBadge.scss";

type ParcelWarningBadgeVariant = "handling-units" | "commodities";

interface ParcelWarningBadgeProps {
  variant?: ParcelWarningBadgeVariant;
  color?: BadgeColor;
}

const MESSAGE_BY_VARIANT: Record<ParcelWarningBadgeVariant, { id: string; defaultMessage: string }> = {
  "handling-units": {
    id: "request-form.packing-list.parcelHandlingUnitWarning",
    defaultMessage: "Please add at least one handling unit for Parcel",
  },
  commodities: {
    id: "request-form.packing-list.parcelWarning",
    defaultMessage: "Commodities' description, HS Code and Value are mandatory for Parcel",
  },
};

export default function ParcelWarningBadge({ variant = "commodities", color = "warning" }: ParcelWarningBadgeProps) {
  const intl = useIntl();
  const message = MESSAGE_BY_VARIANT[variant];

  return (
    <Badge
      type="category-badge"
      color={color}
      size="sm"
      variant="icon-leading"
      icon={<InfoCircleIcon className="rfv2-parcel-warning-badge__icon" />}
      label={intl.formatMessage(message)}
    />
  );
}
